const SCI = require('sci')
const request = require('superagent')

const client = request.agent()
    .use(function (request) {
        const token = SCI.get('token')

        if (!token) {
            return request
        }

        return request.set(
            'authorization',
            token ? `Bearer ${token}` : null
        )
    })

module.exports = {
    query (opts) {
        return new Promise((resolve, reject) => {
            client
                .post(window.__notificationsEndpoint)
                .set('Content-Type', 'application/json')
                .send({
                    variables: opts.variables || {},
                    query: opts.query || ''
                })
                .end((err, res) => {
                    if (err) {
                        return reject(err)
                    }

                    resolve(res.body)
                })
        })
    },
    mutate ({ variables, mutation }) {
        return this.query({
            variables,
            query: mutation
        })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/notifications-client.js